import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRottentomatoesComponent } from './simple-icons-rottentomatoes.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRottentomatoesComponent ],
    exports:      [ SimpleIconsRottentomatoesComponent ],
    bootstrap:    []
})
export class SimpleIconsRottentomatoesModule {}
